



















import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class PowerIcon extends Vue {
  @Prop({ default: 20 })
  width!: number;
  @Prop({ default: 21 })
  height!: number;
  @Prop({ default: "#6E7191" })
  color!: string;
}
